import { Box, Typography, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const operators = [
  { value: "=", label: "Equals (=)" },
  { value: "!=", label: "Not Equal (!=)" },
  { value: ">", label: "Greater Than (>)" },
  { value: ">=", label: "Greater Than or Equal (>=)" },
  { value: "<", label: "Less Than (<)" },
  { value: "<=", label: "Less Than or Equal (<=)" },
  { value: "LIKE", label: "Contains (LIKE)" },
  { value: "NOT LIKE", label: "Does Not Contain (NOT LIKE)" },
  { value: "IN", label: "In (IN)" },
  { value: "NOT IN", label: "Not In (NOT IN)" },
  { value: "IS NULL", label: "Is Null (IS NULL)" },
  { value: "IS NOT NULL", label: "Is Not Null (IS NOT NULL)" },
];

export function ConditionNodeFields({ localNodeData, updateNodeData }) {
  return (
    <>
      <Box>
        <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
          Expresión
        </Typography>
        <TextField
          value={localNodeData.expression || ''}
          size="small"
          fullWidth
          multiline
          rows={4}
          disabled
        />
      </Box>
      <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
        Condición
      </Typography>
      <Box>
        <TextField
          value={localNodeData.value1 || ''}
          size="small"
          fullWidth
          onChange={(e) => {
            const newValue1 = e.target.value;
            const newExpression = `${newValue1} ${localNodeData.operator || ''} ${localNodeData.value2 || ''}`;
            updateNodeData('value1', newValue1);
            updateNodeData('expression', newExpression);
          }}
        />
      </Box>
      <Box>
        <FormControl fullWidth>
          <InputLabel>Condition</InputLabel>
          <Select
            value={localNodeData.operator || ''}
            onChange={(e) => {
              const newOperator = e.target.value;
              const newExpression = `${localNodeData.value1 || ''} ${newOperator} ${localNodeData.value2 || ''}`;
              updateNodeData('operator', newOperator);
              updateNodeData('expression', newExpression);
            }}
            label="Condition"
          >
            {operators.map((operator) => (
              <MenuItem key={operator.value} value={operator.value}>
                {operator.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Box>
        <TextField
          value={localNodeData.value2 || ''}
          size="small"
          fullWidth
          onChange={(e) => {
            const newValue2 = e.target.value;
            const newExpression = `${localNodeData.value1 || ''} ${localNodeData.operator || ''} ${newValue2}`;
            updateNodeData('value2', newValue2);
            updateNodeData('expression', newExpression);
          }}
        />
      </Box>
    </>
  );
}